:host {
  display: block;
  @apply -spw-tw-mx-3;
}

.spw-mosaic--no-masonry {
  display: flex;
  flex-wrap: wrap;
}
